import { motion } from "framer-motion";

const VIDEO_ID = "ba_Xy6U4arM";

export default function VideoSection() {
  return (
    <section className="relative z-10 px-6 py-20 sm:py-28">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="max-w-3xl mx-auto rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl backdrop-saturate-150 p-6 sm:p-10 shadow-[0_8px_32px_rgba(227,11,92,0.15)]"
        data-testid="video-section-card"
      >
        <h2
          className="text-4xl sm:text-5xl text-[#2C1820]"
          style={{ fontFamily: "'Caveat', cursive" }}
        >
          Gen1 Wish
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl shadow-[0_8px_32px_rgba(227,11,92,0.2)]">
          <div className="aspect-video">
            <iframe
              data-testid="video-player-iframe"
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${VIDEO_ID}`}
              title="A song for Noor Fatima"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
}
